export const ROUTE_PATHS = {
  HOME: '/',
  ADMIN: '/admin-dashboard-secret',
  FORUM: '/forum',
  FORUM_CREDITS: '/forum/credits',
  FORUM_MY_QUESTIONS: '/forum/my-questions',
  FORUM_ASK: '/forum/ask',
} as const;

export interface Service {
  id: string;
  title: string;
  description: string;
  price: string;
  duration: string;
  icon: string;
  features: string[];
}

export interface Testimonial {
  id: string;
  name: string;
  rating: number;
  text: string;
  service: string;
  date: string;
}

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  category: string;
  readTime: string;
  image: string;
}

export interface ForumQuestion {
  id: string;
  user_id: string;
  email: string;
  question: string;
  category: 'ljubav' | 'karijera' | 'zdravlje' | 'finansije';
  is_anonymous: boolean;
  display_name: string;
  status: 'pending' | 'answered';
  answer: string | null;
  answered_at: string | null;
  created_at: string;
  likes: number;
  birth_date?: string | null;
  birth_time?: string | null;
  birth_place?: string | null;
}

export interface UserCredits {
  id: string;
  user_id: string;
  email: string;
  credits_remaining: number;
  credits_purchased: number;
  purchase_date: string | null;
  expiry_date: string | null;
  is_expired: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreditPackage {
  id: 'starter' | 'popularan' | 'vip' | 'premium';
  name: string;
  price: number;
  credits: number;
  popular?: boolean;
}

export const CREDIT_PACKAGES: CreditPackage[] = [
  { id: 'starter', name: 'Starter', price: 500, credits: 5 },
  { id: 'popularan', name: 'Popularan', price: 1000, credits: 11, popular: true },
  { id: 'vip', name: 'VIP', price: 2000, credits: 23 },
  { id: 'premium', name: 'Premium', price: 5000, credits: 60 },
];

export const CATEGORY_LABELS = {
  ljubav: '❤️ Ljubav',
  karijera: '💼 Karijera',
  zdravlje: '🏥 Zdravlje',
  finansije: '💰 Finansije',
} as const;

export const SERVICES: Service[] = [
  {
    id: 'natal-chart',
    title: 'Natalna Karta',
    description: 'Profesionalno izrađen PDF dokument sa detaljnom analizom vaše natalne karte - ličnost, talenti, izazovi i životni put.',
    price: '2.000 RSD',
    duration: 'Isporuka do 5 dana',
    icon: 'natal',
    features: [
      'Analiza svih planeta i aspekata',
      'Tumačenje kuća i znakova',
      'Životne lekcije i potencijali',
      'Profesionalno dizajniran PDF',
      'Isporuka na email'
    ]
  },
  {
    id: 'natal-predictions',
    title: 'Natalna Karta + Predikcije',
    description: 'Kompletna natalna karta sa prognozama za narednih 12-24 meseci. Idealno za planiranje budućnosti.',
    price: '3.300 RSD',
    duration: 'Isporuka do 5 dana',
    icon: 'package',
    features: [
      'Kompletna natalna karta',
      'Prognoze za 12-24 meseca',
      'Povoljni periodi za akcije',
      'Upozorenja na izazove',
      'Profesionalno dizajniran PDF'
    ]
  },
  {
    id: 'predictions-only',
    title: 'Samo Predikcije',
    description: 'Fokusirane prognoze za narednih 12-24 meseci zasnovane na vašoj natalnoj karti i trenutnim tranzitima.',
    price: '1.500 RSD',
    duration: 'Isporuka do 5 dana',
    icon: 'transit',
    features: [
      'Prognoze za 12-24 meseca',
      'Analiza ključnih tranzita',
      'Povoljni datumi',
      'Mesečni pregled',
      'PDF format'
    ]
  },
  {
    id: 'synastry',
    title: 'Sinastija - Uporedni Horoskop',
    description: 'Analiza kompatibilnosti i dinamike odnosa između dve osobe kroz poređenje natalnih karti.',
    price: '2.400 RSD',
    duration: 'Isporuka do 5 dana',
    icon: 'synastry',
    features: [
      'Poređenje dve natalne karte',
      'Analiza međusobnih aspekata',
      'Emotivna kompatibilnost',
      'Izazovi i potencijali veze',
      'Profesionalno dizajniran PDF'
    ]
  },
  {
    id: 'three-questions',
    title: 'Tri Pitanja',
    description: 'Dobijte odgovore na tri konkretna pitanja koja vas muče - karijera, ljubav, zdravlje ili bilo koja druga tema.',
    price: '900 RSD',
    duration: 'Isporuka do 5 dana',
    icon: 'consultation',
    features: [
      '3 konkretna pitanja',
      'Detaljni odgovori',
      'Astrološka analiza',
      'Praktični saveti',
      'PDF format'
    ]
  },
  {
    id: 'five-questions',
    title: '5 Pitanja',
    description: 'Proširena konsultacija sa odgovorima na pet vaših najvažnijih pitanja.',
    price: '1.400 RSD',
    duration: 'Isporuka do 5 dana',
    icon: 'consultation',
    features: [
      '5 konkretnih pitanja',
      'Detaljni odgovori',
      'Dubinska analiza',
      'Praktični saveti',
      'PDF format'
    ]
  },
  {
    id: 'ten-questions',
    title: '10 Pitanja',
    description: 'Sveobuhvatna konsultacija sa odgovorima na deset pitanja koja pokrivaju sve oblasti vašeg života.',
    price: '2.700 RSD',
    duration: 'Isporuka do 5 dana',
    icon: 'consultation',
    features: [
      '10 konkretnih pitanja',
      'Detaljni odgovori',
      'Sveobuhvatna analiza',
      'Praktični saveti za sve oblasti',
      'Profesionalno dizajniran PDF'
    ]
  }
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: '1',
    name: 'Marija P.',
    rating: 5,
    text: 'Konsultacija sa Astro Aries Studio je bila transformativno iskustvo. Konačno razumem svoje životne obrasce i imam jasnu viziju puta napred. Profesionalnost i dubina analize su neverovatni.',
    service: 'Natalna Karta',
    date: '2026-02-15'
  },
  {
    id: '2',
    name: 'Stefan M.',
    rating: 5,
    text: 'Analiza tranzita mi je pomogla da donesem ključnu poslovnu odluku u pravom trenutku. Sve što je predviđeno se ostvarilo. Preporučujem svima koji traže vodstvo u životu.',
    service: 'Tranziti i Prognoze',
    date: '2026-01-28'
  },
  {
    id: '3',
    name: 'Ana i Nikola',
    rating: 5,
    text: 'Sinastija nam je otvorila oči na dinamiku naše veze. Razumevanje naših različitosti i komplementarnosti je učinilo našu vezu još jačom. Hvala na ovom dragocenom uvidu!',
    service: 'Sinastija',
    date: '2026-02-10'
  },
  {
    id: '4',
    name: 'Jelena D.',
    rating: 5,
    text: 'Solarna revolucija je bila tačna do detalja. Sve ključne teme godine su se odigrale kako je predviđeno. Sada planiram svaku godinu sa ovom analizom.',
    service: 'Solarna Revolucija',
    date: '2026-01-05'
  },
  {
    id: '5',
    name: 'Miloš K.',
    rating: 5,
    text: 'Profesionalan pristup, duboko znanje i empatija. Dobio sam odgovore na pitanja koja me muče godinama. Astrologija je postala moj kompas u životu.',
    service: 'Personalizovana Konsultacija',
    date: '2026-02-20'
  },
  {
    id: '6',
    name: 'Ivana S.',
    rating: 5,
    text: 'Kompletni paket je najbolja investicija u sebe koju sam napravila. Tri sesije su mi dale sveobuhvatno razumevanje mog života i jasne smernice za budućnost.',
    service: 'Kompletni Paket',
    date: '2026-03-01'
  }
];

export const BLOG_POSTS: BlogPost[] = [
{
    id: '1',
    title: 'Retrogradni Merkur: Mit ili Realnost?',
    excerpt: 'Otkrijte šta zaista znači retrogradni Merkur i kako da iskoristite ovaj period za introspekciju i reviziju umesto da ga se plašite.',
    content: `Retrogradni Merkur je jedan od najpoznatijih astroloških fenomena, ali i najviše pogrešno tumačen. Tri do četiri puta godišnje, Merkur - planeta komunikacije, tehnologije i putovanja - izgleda kao da se kreće unazad sa naše perspektive sa Zemlje.

**Šta se zaista dešava?**

Retrogradnost je optička iluzija. Merkur se ne kreće unazad, već usporava u odnosu na Zemlju, stvarajući privid retrogradnog kretanja. Ovaj period traje oko 3 nedelje i događa se kada je Merkur najbliži Zemlji, što pojačava njegov uticaj.

**Uticaj na svakodnevni život:**

• **Komunikacija**: Nedorazumevi, kašnjenja poruka, potreba za ponovnim objašnjavanjem
• **Tehnologija**: Kvarovi uređaja, problemi sa softverom, gubici podataka
• **Putovanja**: Odlaganja, promena planova, izgubljeni dokumenti
• **Ugovori**: Potreba za revizijom, skriveni detalji, nedostajuće informacije

**Kako iskoristiti ovaj period?**

Umesto straha, retrogradni Merkur je vreme za:

1. **Reviziju** - Pregledajte stare projekte, ispravite greške
2. **Introspekciju** - Razmislite o načinu komunikacije
3. **Ponovno povezivanje** - Kontaktirajte stare prijatelje
4. **Završetak** - Dovršite nezavršene poslove

**Praktični saveti:**

• Pravite rezervne kopije podataka
• Provjeravajte detalje dvaput
• Budite strpljivi u komunikaciji
• Izbjegavajte potpisivanje važnih ugovora ako je moguće
• Koristite vreme za planiranje, ne za pokretanje novih projekata

Retrogradni Merkur nije vaš neprijatelj - to je kosmički poziv na usporavanje i svesnost.`,
    date: '2026-03-10',
    category: 'Planete',
    readTime: '5 min',
    image: 'COSMIC_BG_1'
  },
{
    id: '2',
    title: 'Mesečevi Čvorovi: Vaš Karmički Put',
    excerpt: 'Severni i Južni čvor otkrivaju vašu dušinu misiju i lekcije koje ste došli da naučite u ovom životu. Saznajte kako da ih tumačite.',
    content: `Mesečevi čvorovi nisu planete, već matematičke tačke gde se putanja Meseca siječe sa ekliptikom (putanjom Sunca). Ove tačke otkrivaju najdublji smisao vašeg života i dušinu evoluciju.

**Južni Čvor (South Node) - Vaša Prošlost**

Južni čvor predstavlja:
• Urođene talente i sposobnosti
• Karmičke obrasce iz prošlih života
• Ono što vam dolazi prirodno
• Zona komfora koja može postati zamka

Znak i kuća Južnog čvora pokazuju gde ste već majstori, ali gde više ne treba da se zadržavate.

**Severni Čvor (North Node) - Vaša Sudbina**

Severni čvor predstavlja:
• Dušinu misiju u ovom životu
• Kvalitete koje treba da razvijete
• Pravac rasta i evolucije
• Ono što donosi ispunjenje

Znak i kuća Severnog čvora pokazuju gde treba da idete, šta da učite i kako da se razvijate.

**Primeri po znakovima:**

**Južni Čvor u Ovnu / Severni u Vagi:**
Prošlost: Nezavisnost, borbenost, individualizam
Misija: Naučiti saradnju, kompromis, partnerstvo

**Južni čvor u Biku / Severni u Škorpiji:**
Prošlost: Materijalnost, sigurnost, stabilnost
Misija: Transformacija, dubina, emocionalna intimnost

**Južni čvor u Blizancima / Severni u Strelcu:**
Prošlost: Informacije, komunikacija, raznovrsnost
Misija: Muđrost, filozofija, više značenje

**Kako raditi sa čvorovima:**

1. **Prepoznajte obrasce** - Južni čvor pokazuje vaše automatske reakcije
2. **Izazovite sebe** - Svesno se krećite ka Severnom čvoru
3. **Balans** - Ne napustite potpuno Južni čvor, koristite ga kao osnovu
4. **Strpljenje** - Razvoj ka Severnom čvoru je proces celog života

Čvorovi menjaju znakove svakih 18 meseci, ali vaši natalni čvorovi ostaju vaš životni kompas.`,
    date: '2026-03-05',
    category: 'Natalna Karta',
    readTime: '7 min',
    image: 'MOON_PHASES_1'
  },
{
    id: '3',
    title: 'Venera u Znakovima: Jezik Ljubavi',
    excerpt: 'Pozicija Venere u vašoj natalnoj karti otkriva kako volite, šta vas privlači i kako izražavate naklonost. Vodič kroz sve znakove.',
    content: `Venera, planeta ljubavi, lepote i vrednosti, otkriva vaš jedinstveni jezik ljubavi. Njen položaj u natalnoj karti pokazuje šta vas privlači, kako izražavate naklonost i šta vam donosi zadovoljstvo u vezama.

**Venera u Vatreним Znakovima (Ovan, Lav, Strelac)**

**Venera u Ovnu:**
• Voli uzbuđenje i izazov
• Direktna i spontana u ljubavi
• Privlači je nezavisnost i hrabrost
• Brzo se zaljubljuje, ali traži stalnu stimulaciju

**Venera u Lavu:**
• Veličanstvena i velikodušna u ljubavi
• Traži divljenje i poštovanje
• Voli romantične geste i drama
• Lojalna i strastvena kada je zaljubljena

**Venera u Strelcu:**
• Traži slobodu i avanturu
• Privlači je intelekt i humor
• Voli putovanja i filozofske razgovore
• Optimistična i otvorena u ljubavi

**Venera u Zemaljskim Znakovima (Bik, Devica, Jarac)**

**Venera u Biku (Domicil):**
• Senzualna i fizička ljubav
• Traži stabilnost i sigurnost
• Voli luksuz i udobnost
• Verna i posvećena partneru

**Venera u Devici:**
• Praktična i uslužna ljubav
• Pokazuje ljubav kroz brižnje
• Traži savršenstvo u partneru
• Skromna ali duboko odana

**Venera u Jarcu:**
• Ozbiljna i odgovorna u vezama
• Traži dugoročnu stabilnost
• Privlači je ambicija i zrelost
• Sporo se otvara, ali je lojalna

**Venera u Vazdušnim Znakovima (Blizanci, Vaga, Vodolija)**

**Venera u Blizancima:**
• Intelektualna i komunikativna ljubav
• Traži mentalnu stimulaciju
• Voli flert i razgovor
• Potrebna joj je raznovrsnost

**Venera u Vagi (Domicil):**
• Romantična i harmonična
• Traži ravnotežu i lepotu
• Diplomatična i šarmantna
• Prirodno partnerski orijentisana

**Venera u Vodoliji:**
• Nekonvencionalna i prijateljska ljubav
• Traži intelektualnu povezanost
• Ceni slobodu i individualnost
• Originalna u izražavanju naklonosti

**Venera u Vodenim Znakovima (Rak, Škorpija, Ribe)**

**Venera u Raku:**
• Brižna i zaštitnička ljubav
• Traži emocionalnu sigurnost
• Voli porodicu i dom
• Intuitivna i osjetljiva

**Venera u Škorpiji:**
• Intenzivna i strastvena ljubav
• Traži duboku emocionalnu intimnost
• Lojalna do ekstremnosti
• Transformativna u vezama

**Venera u Ribama (Egzaltacija):**
• Bezuslovna i saosjećajna ljubav
• Romantična i idealična
• Intuitivna i empatična
• Voli da se žrtvuje za voljenu osobu

**Kako koristiti ovo znanje:**

1. Razumite svoj jezik ljubavi
2. Upoznajte Veneru partnera za bolju kompatibilnost
3. Prihvatite razlike u izražavanju ljubavi
4. Koristite snage svoje Venere svesno

Venera u natalnoj karti je ključ za ispunjene i harmonične veze.`,
    date: '2026-02-28',
    category: 'Ljubav',
    readTime: '8 min',
    image: 'SPIRITUAL_1'
  },
{
    id: '4',
    title: 'Saturn Return: Vaš Astrološki Odrasli Ritual',
    excerpt: 'Između 28. i 30. godine, Saturn se vraća na svoju natalnu poziciju. Ovo je period zrelosti, odgovornosti i životnih lekcija.',
    content: `Saturn Return je jedan od najznačajnijih astroloških tranzita u životu. Događa se kada Saturn, planeta strukture i odgovornosti, završi svoj 29-godišnji ciklus i vrati se na tačnu poziciju koju je imao u trenutku vašeg rođenja.

**Kada se događa?**

• **Prvi Saturn Return**: 28-30 godina - Prelazak u pravu odraslost
• **Drugi Saturn Return**: 57-59 godina - Mudrost i nasleđe
• **Treći Saturn Return**: 86-88 godina - Duhovna zrelost

**Šta Saturn Return donosi?**

Saturn je "kosmički učitelj" koji postavlja teška pitanja:

• Da li živim autentičan život?
• Da li sam na pravom putu?
• Šta moram da promenim?
• Koje odgovornosti moram da prihvatim?

Ovaj period često donosi:

**Izazovi:**
• Završetak veza koje nisu autentične
• Promena karijere ili životnog pravca
• Suočavanje sa strahovima
• Osjećaj krize i neizvesnosti
• Povećana odgovornost

**Mogućnosti:**
• Osnivanje čvrste životne osnove
• Prihvatanje prave odgovornosti
• Razvoj discipline i zrelosti
• Izgradnja dugoročnih ciljeva
• Pronalaženje autentičnog puta

**Kako proći kroz Saturn Return?**

1. **Prihvatite promene** - Ono što odlazi, treba da ode
2. **Budite iskreni** - Saturn kažnjava laži i samozavaravanje
3. **Radite naporno** - Saturn nagrađuje trud i disciplinu
4. **Tražite podršku** - Terapeut ili astrolog mogu pomoći
5. **Budite strpljivi** - Proces traje 2-3 godine

**Znakovi da ste u Saturn Return-u:**

• Osjećaj da više ne možete nastaviti kao do sada
• Velike životne promene (posao, veza, mesto stanovanja)
• Povećana odgovornost
• Suočavanje sa realnosti
• Potreba za autentičnošću

**Nakon Saturn Return-a:**

Kada Saturn završi svoj tranzit, osjećate:
• Veću jasnoću o sebi
• Čvrstu životnu osnovu
• Zrelost i mudrost
• Samopouzdanje u svojim izborima

Saturn Return nije kazna - to je inicijacija u pravu odraslost i autentičan život.`,
    date: '2026-02-20',
    category: 'Tranziti',
    readTime: '6 min',
    image: 'NATAL_CHART_1'
  },
  {
    id: '5',
    title: 'Ascendent: Vaša Maska i Prvi Utisak',
    excerpt: 'Ascendent je način na koji svet vas vidi i kako pristupate životu. Otkrijte kako vaš Ascendent oblikuje vašu ličnost.',
    content: `Ascendent (ili Uzlazni znak) je jedan od najvažnijih elemenata natalne karte. To je znak koji se nalazio na istočnom horizontu u trenutku vašeg rođenja i predstavlja vašu "masku" - način na koji svet vas vidi i kako vi pristupate životu.

**Šta je Ascendent?**

Ascendent je:
• Vaš prvi utisak na druge
• Način na koji se predstavljate svetu
• Vaš pristup novim situacijama
• Fizički izgled i maniri
• Spontane reakcije

**Razlika između Sunčevog znaka i Ascendenta:**

**Sunčev znak** = Ko ste u suštini (vaša duša)
**Ascendent** = Kako se pokazujete (vaša ličnost)

Na primer: Možete biti Rak po Sunčevom znaku (osjetljiv, emotivan), ali sa Ascendentom u Lavu (samopouzdan, dramatičan izgled).

**Ascendent kroz znakove:**

**Vatreni Ascendenti:**
• **Ovan**: Energičan, direktan, impulsivan prvi utisak
• **Lav**: Samopouzdan, karizmatičan, dramatičan
• **Strelac**: Optimističan, avanturističan, filozofski

**Zemaljski Ascendenti:**
• **Bik**: Miran, stabilan, senzualan izgled
• **Devica**: Uredan, skroman, analitičan
• **Jarac**: Ozbiljan, odgovoran, profesionalan

**Vazdušni Ascendenti:**
• **Blizanci**: Komunikativan, radoznao, živahan
• **Vaga**: Šarmantan, diplomatičan, estetski
• **Vodolija**: Originalan, nekonvencionalan, prijateljski

**Vodeni Ascendenti:**
• **Rak**: Brižan, zaštitnički, emotivan
• **Škorpija**: Intenzivan, magnetičan, misteriozan
• **Ribe**: Sanjalački, empatičan, umetnički

**Kako Ascendent utiče na vaš život:**

1. **Fizički izgled**: Ascendent utiče na vaš izgled, držanje, stil
2. **Prve impresije**: Kako vas ljudi doživljavaju pri prvom susretu
3. **Pristup životu**: Vaša spontana reakcija na situacije
4. **Zdravlje**: Ascendent pokazuje sklone delove tela
5. **Životni put**: Pravac vašeg razvoja

**Vladajuća planeta Ascendenta:**

Znak vašeg Ascendenta ima vladajuću planetu koja dodatno oblikuje vašu ličnost:

• Ovan/Škorpija: Mars
• Bik/Vaga: Venera
• Blizanci/Devica: Merkur
• Rak: Mesec
• Lav: Sunce
• Strelac: Jupiter
• Jarac: Saturn
• Vodolija: Uran
• Ribe: Neptun

**Kako saznati svoj Ascendent:**

Potrebno vam je:
• Tačan datum rođenja
• Tačno vreme rođenja (do minuta!)
• Mesto rođenja

Ascendent se menja svakih 2 sata, zato je tačno vreme ključno!

Razumevanje vašeg Ascendenta pomaže vam da:
• Razumete kako vas drugi vide
• Iskoristite svoju prirodnu "masku"
• Integrišete svoju unutrašnju i spoljašnju ličnost
• Razvijete autentičan izraz sebe`,
    date: '2026-02-15',
    category: 'Natalna Karta',
    readTime: '6 min',
    image: 'HERO_BACKGROUND_1'
  },
  {
    id: '6',
    title: 'Punoća Meseca: Ritual Oslobođanja',
    excerpt: 'Punoća Meseca je vreme kulminacije i oslobođanja. Naučite kako da kreirate ritual koji će vam pomoći da pustite ono što vam više ne služi.',
    content: `Punoća Meseca je najmoćnija faza lunarnog ciklusa - vreme kada je Mesec potpuno osvetljen Suncem i nalazi se nasuprot njemu. Ovo je period kulminacije, oslobođanja i zahvalnosti.

**Energija Punoće Meseca:**

Punoća donosi:
• Kulminaciju projekata i situacija
• Jasnoću i otkrovenja
• Pojačane emocije
• Završetke i oslobođanja
• Manifestaciju namera

Ovo je vreme kada:
• Stvari dolaze na svetlo
• Emocije su na vrhuncu
• Rezultati postaju vidljivi
• Potrebno je pustiti ono što ne služi

**Ritual Oslobođanja za Punoću Meseca:**

**Priprema (dan pre ili na dan Punoće):**

1. **Očistite prostor**
   • Zapalite beli šalfe ili palo santo
   • Otvorite prozore
   • Uklonite nered

2. **Pripremite materijale**
   • Papir i olovka
   • Sveća (bela ili srebrna)
   • Posuda sa vodom
   • So (za zaštitu)
   • Kristali (selenite, mesečev kamen)

**Ritual (najbolje uveče):**

**Korak 1: Kreiranje Svetog Prostora**
• Zapalite sveću
• Postavite kristale u krug
• Sedite udobno

**Korak 2: Centriranje**
• Zatvorite oči
• Duboko dišite 5 minuta
• Povežite se sa energijom Meseca

**Korak 3: Pisanje**
Napišite sve što želite da pustite:
• Negativne emocije (strah, bes, tuga)
• Ograničavajuća uverenja
• Toške veze ili situacije
• Loše navike
• Sve što vam više ne služi

**Korak 4: Izgovaranje**
Glasno pročitajte svaku stavku i recite:
"Punoćo Meseca, oslobođam [stavka]. Hvala ti što si me učila, ali više ti ne pripadam. Pustaš te sa ljubavlju."

**Korak 5: Oslobođanje**
Imate tri opcije:
• **Vatra**: Bezbedno spalite papir (najbolje)
• **Voda**: Potopite papir u vodu preko noći, zatim bacite
• **Zemlja**: Zakopajte papir

**Korak 6: Zahvalnost**
Napišite 10 stvari za koje ste zahvalni.
Ovo puni prostor koji ste oslobodili pozitivnom energijom.

**Korak 7: Zatvaranje**
• Zahvalite Mesecu
• Ugasite sveću
• Popijte čašu vode (simboličko čišćenje)

**Dodatne prakse za Punoću:**

• **Mesečevo kupatilo**: Dodajte so i eterična ulja
• **Punjenje kristala**: Ostavite ih na mesečini preko noći
• **Meditacija**: Vizualizujte belu svetlost
• **Jurnal**: Zapišite otkrovenja i uvide

**Znakovi uspešnog rituala:**

• Osjećaj lakoće i olakšanja
• Jasnoća uma
• Bolje raspoloženje
• Sinhroniciteti u narednim danima
• Prirodno odvajanje od starih obrazaca

**Važno:**

• Ritual radite sa namerom, ne mehanički
• Budite iskreni sa sobom
• Pustite kontrolu nad ishodom
• Verujte procesu

Punoća Meseca se događa svakih 29.5 dana - iskoristite ovu moćnu energiju za kontinuirano oslobođanje i rast!`,
    date: '2026-02-10',
    category: 'Lunarna Astrologija',
    readTime: '5 min',
    image: 'MOON_PHASES_2'
  }
];

// Horoskop interfejsi
export interface ZodiacSign {
  id: string;
  name: string;
  symbol: string;
  element: string;
  dates: string;
}

export interface MonthlyHoroscope {
  sign: string;
  month: string;
  year: number;
  content: string;
}

export interface YearlyHoroscope {
  sign: string;
  year: number;
  content: string;
}

// Znakovi zodijaka
export const ZODIAC_SIGNS: ZodiacSign[] = [
  { id: 'ovan', name: 'Ovan', symbol: '♈', element: 'Vatra', dates: '21.03 - 19.04' },
  { id: 'bik', name: 'Bik', symbol: '♉', element: 'Zemlja', dates: '20.04 - 20.05' },
  { id: 'blizanci', name: 'Blizanci', symbol: '♊', element: 'Vazduh', dates: '21.05 - 20.06' },
  { id: 'rak', name: 'Rak', symbol: '♋', element: 'Voda', dates: '21.06 - 22.07' },
  { id: 'lav', name: 'Lav', symbol: '♌', element: 'Vatra', dates: '23.07 - 22.08' },
  { id: 'devica', name: 'Devica', symbol: '♍', element: 'Zemlja', dates: '23.08 - 22.09' },
  { id: 'vaga', name: 'Vaga', symbol: '♎', element: 'Vazduh', dates: '23.09 - 22.10' },
  { id: 'skorpija', name: 'Škorpija', symbol: '♏', element: 'Voda', dates: '23.10 - 21.11' },
  { id: 'strelac', name: 'Strelac', symbol: '♐', element: 'Vatra', dates: '22.11 - 21.12' },
  { id: 'jarac', name: 'Jarac', symbol: '♑', element: 'Zemlja', dates: '22.12 - 19.01' },
  { id: 'vodolija', name: 'Vodolija', symbol: '♒', element: 'Vazduh', dates: '20.01 - 18.02' },
  { id: 'ribe', name: 'Ribe', symbol: '♓', element: 'Voda', dates: '19.02 - 20.03' }
];
